import React from 'react';
import ReactDOM from 'react-dom/client'; // Notez le changement ici
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter> {/* Envelopper App dans BrowserRouter */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);